module.exports = "/images/vendor/desiigner-svg/svg/logos/lonelyplanet-shop.svg?55eb3b8691a327868b2bcd3460710d9b";